import React, { useMemo } from 'react'
import { BasePublisherButton } from '../base-publisher-button'
import {
  FormInterface,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'
import { useOptInSubmitForm } from './hooks/use-opt-in-submit-form'

const TEST_ID = 'submit-form-button'

interface FormSubmitButtonSubentityProps
  extends Pick<
    ReturnType<typeof useOptInSubmitForm>,
    'isLoading' | 'errors' | 'onSubmit'
  > {
  formEntity: FormInterface
  submitButtonSubentity: FormSubmitButtonInterface
}

export const FormSubmitButtonSubentity = ({
  formEntity,
  submitButtonSubentity,
  isLoading,
  errors,
  onSubmit,
}: FormSubmitButtonSubentityProps) => {
  const entity = useMemo(
    () => ({
      ...submitButtonSubentity,
      ...formEntity.buttonCommonStyles,
    }),
    [submitButtonSubentity, formEntity.buttonCommonStyles],
  )
  return (
    <BasePublisherButton
      testId={TEST_ID}
      entity={entity}
      onClick={onSubmit}
      errors={errors}
      isLoading={isLoading}
    />
  )
}
